import * as React from "react";
import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';

/* interface Category {
    id: number;
    category: string;
}

const categories: Category[] = [{
    id: 1, 
    category: "Automoviles"
},
{
    id: 2, 
    category: "Bienes Raices"
},
{
    id: 3, 
    category: "Electronicos"
}] */

const CategoryItem: React.FC<{category: string, avisos: {avisos: any[], banner: string}, DeviceID: string, ap: any, bc_seconds: number}> = ({category, avisos, DeviceID, ap, bc_seconds}) => {
    const postImpressionCategory = async() => {
        try {
            const fields = {
                AccessPointID: ap.ap_mac,
                LocationID: Number(ap.ap_locationid),
                DeviceID,
                CampaignID: 0,
                MediaType: category
              };
              await axios.post("/impressions", {fields} );
        } catch (error) {
            
        }
    }

    const urlBanner  = avisos.banner.includes("storage.googleapis") ? `/google-storage/${encodeURIComponent(avisos.banner)}` : avisos.banner;

   /*  return (
        <div className="card m-1">
            <Link to={{
                pathname:`/avisos/${category}`,
                state: {
                    avisos: avisos.avisos,
                    header: category
                }
            }} className="card-body" onClick={() => postImpressionCategory()}>
                {category}
            </Link>
        </div>
    )
 */
    return (
        <div
        style={{
          marginTop: "8px"
        }}
      >
        <Link
          style={{
            padding: 0,
            borderRadius: "20px"
          }}
          onClick={() => postImpressionCategory()}
          className="list-group-item list-group-item-action flex-column align-items-start"
          style={{
            padding: "0",
            borderWidth: "0"
          }}
          to={{
            pathname:`/avisos/${category}`,
            state: {
                avisos: avisos.avisos,
                header: category,
                bc_seconds
            }
        }} 
        >
          <div
          className="row ml-1 mr-1"
            style={{
              height: "6.8em",
              borderRadius: "20px",
              justifyContent: "center"
            }}
          >
  
            <div
            className="col-11"
              style={{
                height: "100%",
                borderRadius: "20px 0px 0px 20px",
                backgroundImage: `url(${urlBanner})`,
                backgroundPosition: "center",
                backgroundSize: "cover"
              }}
            >
            </div>
  
            <button className="btn btn-lg btn-danger col-1" 
            style={{
              height: "100%",
              textAlign: "center",
              padding: 0,
              borderRadius: "0px 20px 20px 0px"
            }}>&raquo;</button>
           
          </div>
        </Link>
      </div>
      );
}

const OcationsAds = ({DeviceID, ap}) => {
    const [avisos, setAvisos] = useState({});
    const [categories, setCategories] = useState([]);
    let location = useLocation();
    const {bc_seconds} = location.state;
    useEffect(() => {
        _getAvisos();
    }, []);

    const _getAvisos = () => {
        let av = location.state.avisos;
        if(av) {
            let keys = Object.keys(av);
            setCategories(keys);
            setAvisos(location.state.avisos);
        }

    }


    return (
        <div className="row w-100" style={{
            maxWidth: "700px",
        }}>
            <div className="col-12" style={{
                backgroundColor: "#dc3545"
            }}>
                <h3 className="m-1" style={{color: "#fff"}}>Categorias</h3> 
            </div>
            <div className="col-12 pt-1">
            {
                categories.map((v) => <CategoryItem key={v} category={v} avisos={avisos[v]} DeviceID={DeviceID ? DeviceID : location.state.device_id} ap={ap} bc_seconds={bc_seconds}/>)
            }
            </div>
        </div>
    )
}

export default OcationsAds
